/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.30/esri/copyright.txt for details.
*/
var R,E;!function(R){R[R.RED=0]="RED",R[R.RG=1]="RG",R[R.RGBA4=2]="RGBA4",R[R.RGBA=3]="RGBA",R[R.RGBA_MIPMAP=4]="RGBA_MIPMAP",R[R.R16F=5]="R16F",R[R.RGBA16F=6]="RGBA16F"}(R||(R={})),function(R){R[R.DEPTH_STENCIL_TEXTURE=0]="DEPTH_STENCIL_TEXTURE",R[R.DEPTH16_BUFFER=1]="DEPTH16_BUFFER"}(E||(E={}));export{R as ColorFormat,E as DepthFormat};
